import Bouncer from 'formbouncerjs/dist/bouncer.js'

export default function () {
  Bouncer('form', {
    fieldClass: 'form__error',
    errorClass: 'form__error-message',

    // Custom Validations
    customValidations: {
      outOfDateRange: function (field) {
        let date = field.getAttribute('type') === 'date'
        if (!date || !field.value || field.value.length < 1) {
          return false
        }

        // Check for range
        let max = field.getAttribute('max')
        let maxDate = new Date(max)
        let min = field.getAttribute('min')
        let minDate = new Date(min)

        // Check validity
        let num = new Date(field.value)
        if (maxDate && num > maxDate) return 'over'
        if (minDate && num < minDate) return 'under'
        return false
      }
    },

    // Message Settings
    messageAfterField: true, // If true, displays error message below field. If false, displays it above.
    messageCustom: 'data-bouncer-message', // The data attribute to use for customer error messages

    // Error messages by error type
    messages: {
      missingValue: {
        checkbox: 'Dieses Feld ist ein Pflichtfeld.',
        radio: 'Bitte wählen Sie eine Option aus.',
        select: 'Bitte wählen Sie eine Option aus.',
        'select-multiple': 'Bitte wählen Sie mindestens eine Option aus.',
        default: 'Dieses Feld ist ein Pflichtfeld.'
      },
      patternMismatch: {
        email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
        number: 'Bitte geben Sie eine Nummer ein',
        default: 'Bitte achten Sie auf das richtige Format.'
      },
      outOfDateRange: function (field) {
        let customMessage = field.getAttribute('data-bouncer-message')
        if (customMessage) { return customMessage } else { return 'Fehlerhafte Eingabe.' }
      }
    }
  })
}
